/*! Respond.js v1.1.0: min/max-width media query polyfill. (c) Scott Jehl. MIT/GPLv2 Lic. j.mp/respondjs  */
(function(e){e.respond={};respond.update=function(){};respond.mediaQueriesSupported=e.matchMedia&&e.matchMedia("only all").matches;if(respond.mediaQueriesSupported){return}var w=e.document,s=w.documentElement,i=[],k=[],q=[],o={},h=30,f=w.getElementsByTagName("head")[0]||s,g=w.getElementsByTagName("base")[0],b=f.getElementsByTagName("link"),d=[],a=function(){var D=b,y=D.length,B=0,A,z,C,x;for(;B<y;B++){A=D[B],z=A.href,C=A.media,x=A.rel&&A.rel.toLowerCase()==="stylesheet";if(!!z&&x&&!o[z]){if(A.styleSheet&&A.styleSheet.rawCssText){m(A.styleSheet.rawCssText,z,C);o[z]=true}else{if((!/^([a-zA-Z:]*\/\/)/.test(z)&&!g)||z.replace(RegExp.$1,"").split("/")[0]===e.location.host){d.push({href:z,media:C})}}}}u()},u=function(){if(d.length){var x=d.shift();n(x.href,function(y){m(y,x.href,x.media);o[x.href]=true;u()})}},m=function(I,x,z){var G=I.match(/@media[^\{]+\{([^\{\}]*\{[^\}\{]*\})+/gi),J=G&&G.length||0,x=x.substring(0,x.lastIndexOf("/")),y=function(K){return K.replace(/(url\()['"]?([^\/\)'"][^:\)'"]+)['"]?(\))/g,"$1"+x+"$2$3")},A=!J&&z,D=0,C,E,F,B,H;if(x.length){x+="/"}if(A){J=1}for(;D<J;D++){C=0;if(A){E=z;k.push(y(I))}else{E=G[D].match(/@media *([^\{]+)\{([\S\s]+?)$/)&&RegExp.$1;k.push(RegExp.$2&&y(RegExp.$2))}B=E.split(",");H=B.length;for(;C<H;C++){F=B[C];i.push({media:F.split("(")[0].match(/(only\s+)?([a-zA-Z]+)\s?/)&&RegExp.$2||"all",rules:k.length-1,hasquery:F.indexOf("(")>-1,minw:F.match(/\(min\-width:[\s]*([\s]*[0-9\.]+)(px|em)[\s]*\)/)&&parseFloat(RegExp.$1)+(RegExp.$2||""),maxw:F.match(/\(max\-width:[\s]*([\s]*[0-9\.]+)(px|em)[\s]*\)/)&&parseFloat(RegExp.$1)+(RegExp.$2||"")})}}j()},l,r,v=function(){var z,A=w.createElement("div"),x=w.body,y=false;A.style.cssText="position:absolute;font-size:1em;width:1em";if(!x){x=y=w.createElement("body");x.style.background="none"}x.appendChild(A);s.insertBefore(x,s.firstChild);z=A.offsetWidth;if(y){s.removeChild(x)}else{x.removeChild(A)}z=p=parseFloat(z);return z},p,j=function(I){var x="clientWidth",B=s[x],H=w.compatMode==="CSS1Compat"&&B||w.body[x]||B,D={},G=b[b.length-1],z=(new Date()).getTime();if(I&&l&&z-l<h){clearTimeout(r);r=setTimeout(j,h);return}else{l=z}for(var E in i){var K=i[E],C=K.minw,J=K.maxw,A=C===null,L=J===null,y="em";if(!!C){C=parseFloat(C)*(C.indexOf(y)>-1?(p||v()):1)}if(!!J){J=parseFloat(J)*(J.indexOf(y)>-1?(p||v()):1)}if(!K.hasquery||(!A||!L)&&(A||H>=C)&&(L||H<=J)){if(!D[K.media]){D[K.media]=[]}D[K.media].push(k[K.rules])}}for(var E in q){if(q[E]&&q[E].parentNode===f){f.removeChild(q[E])}}for(var E in D){var M=w.createElement("style"),F=D[E].join("\n");M.type="text/css";M.media=E;f.insertBefore(M,G.nextSibling);if(M.styleSheet){M.styleSheet.cssText=F}else{M.appendChild(w.createTextNode(F))}q.push(M)}},n=function(x,z){var y=c();if(!y){return}y.open("GET",x,true);y.onreadystatechange=function(){if(y.readyState!=4||y.status!=200&&y.status!=304){return}z(y.responseText)};if(y.readyState==4){return}y.send(null)},c=(function(){var x=false;try{x=new XMLHttpRequest()}catch(y){x=new ActiveXObject("Microsoft.XMLHTTP")}return function(){return x}})();a();respond.update=a;function t(){j(true)}if(e.addEventListener){e.addEventListener("resize",t,false)}else{if(e.attachEvent){e.attachEvent("onresize",t)}}})(this);

/*
 HTML5 Shiv v3.7.0 | @afarkas @jdalton @jon_neal @rem | MIT/GPL2 Licensed
*/
(function(l,f){function m(){var a=e.elements;return"string"==typeof a?a.split(" "):a}function i(a){var b=n[a[o]];b||(b={},h++,a[o]=h,n[h]=b);return b}function p(a,b,c){b||(b=f);if(g)return b.createElement(a);c||(c=i(b));b=c.cache[a]?c.cache[a].cloneNode():r.test(a)?(c.cache[a]=c.createElem(a)).cloneNode():c.createElem(a);return b.canHaveChildren&&!s.test(a)?c.frag.appendChild(b):b}function t(a,b){if(!b.cache)b.cache={},b.createElem=a.createElement,b.createFrag=a.createDocumentFragment,b.frag=b.createFrag();
a.createElement=function(c){return!e.shivMethods?b.createElem(c):p(c,a,b)};a.createDocumentFragment=Function("h,f","return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&("+m().join().replace(/[\w\-]+/g,function(a){b.createElem(a);b.frag.createElement(a);return'c("'+a+'")'})+");return n}")(e,b.frag)}function q(a){a||(a=f);var b=i(a);if(e.shivCSS&&!j&&!b.hasCSS){var c,d=a;c=d.createElement("p");d=d.getElementsByTagName("head")[0]||d.documentElement;c.innerHTML="x<style>article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}mark{background:#FF0;color:#000}template{display:none}</style>";
c=d.insertBefore(c.lastChild,d.firstChild);b.hasCSS=!!c}g||t(a,b);return a}var k=l.html5||{},s=/^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,r=/^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i,j,o="_html5shiv",h=0,n={},g;(function(){try{var a=f.createElement("a");a.innerHTML="<xyz></xyz>";j="hidden"in a;var b;if(!(b=1==a.childNodes.length)){f.createElement("a");var c=f.createDocumentFragment();b="undefined"==typeof c.cloneNode||
"undefined"==typeof c.createDocumentFragment||"undefined"==typeof c.createElement}g=b}catch(d){g=j=!0}})();var e={elements:k.elements||"abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output progress section summary template time video",version:"3.7.0",shivCSS:!1!==k.shivCSS,supportsUnknownElements:g,shivMethods:!1!==k.shivMethods,type:"default",shivDocument:q,createElement:p,createDocumentFragment:function(a,b){a||(a=f);
if(g)return a.createDocumentFragment();for(var b=b||i(a),c=b.frag.cloneNode(),d=0,e=m(),h=e.length;d<h;d++)c.createElement(e[d]);return c}};l.html5=e;q(f)})(this,document);
!function (e) { e.fn.viewportChecker = function (t) { var n = { classToAdd: "visible", offset: 100, callbackFunction: function () { }, children: false, childClasses: ''}; e.extend(n, t); var i = this, s = e(window).height(); this.checkElements = function () { var t = -1 != navigator.userAgent.toLowerCase().indexOf("webkit") ? window : window, o = e(t).scrollTop(), c = o + s; i.each(function () { var t = e(this); if (!t.hasClass(n.classToAdd)) { var i = Math.round(t.offset().top) + n.offset, s = i + t.height(); c > i && s > o && ((n.children ? t.find(n.childClasses): t).addClass(n.classToAdd), n.callbackFunction(t)) } }) }, e(window).scroll(this.checkElements), this.checkElements(), e(window).resize(function (e) { s = e.currentTarget.innerHeight }).resize() } }(jQuery);

$(document).ready(function() {

	function getCookie(cname) {
	    var name = cname + "=";
	    var ca = document.cookie.split(';');
	    for(var i=0; i<ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0)==' ') c = c.substring(1);
	        if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
	    }
	    return null;
	}

	function createCookie(cname, cvalue, exdays) {
	    var d = new Date();
	    d.setTime(d.getTime() + (exdays*24*60*60*1000));
	    var expires = "expires="+d.toUTCString();
	    document.cookie = cname + "=" + cvalue + "; " + expires;
	}

	function readCookie(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
		}
		return null;
	}

	function eraseCookie(name) {
		createCookie(name,"",-1);
	}

	//detects if under ie9 and displays a message.
	var ie = (function(){
	    var undef,
	        v = 3,
	        div = document.createElement('div'),
	        all = div.getElementsByTagName('i');

	    while (
	        div.innerHTML = '<!--[if gt IE ' + (++v) + ']><i></i><![endif]-->',
	        all[0]
	    );
	    return v > 4 ? v : undef;
	}());

	if (ie < 9 ){
		var popupCookie = getCookie("rememberpopup");
		if (popupCookie == null){
			var message = "<div class='browser-message'>\
						   <h3>Browser outdated.</h3>\
						   <p>You are using an outdated browser. To get the best experience from this website install Chrome, Firefox or Internet Explore 9+. Thank you.</p>\
						   <span class='btn js-message-close'>Close</span>\
						   <p><small>*By closing this message you accept the use of cookies on this website.</small></p>\
					   </div>",
			messageOverlay = "<div class='message-overlay'></div>";

			$(message).appendTo('.message-overlay');
			$('.message-overlay').show();
		}
	}

	$('.js-message-close').on('click', function(){
		createCookie('rememberpopup','Remember Popup',1);
		//readCookie(rememberpopup);
		$('.message-overlay').hide();
	});


	$('a[rel^="external"]').click( function() {
		window.open( $(this).attr('href') );
		return false;
	});

	$(window).resize(resize);


	$('body').on('click','.js-nav-toggle', function(){
		$('body').toggleClass('show-nav');
		//refreshObj('#logo-icon');
		//refreshObj('#logo-title');
		return false;
	}).on('click','.js-nav-treatments', function(){
		if($(window).width() >= 760){ return false; }
		$('.js-treatment-nav').toggleClass('show-treatments');
		$(this).toggleClass('arrow-flip');
		return false;
	}).on('submit', '#contact-form', function(){
		$(this).find(".loading-errors").html(svgLoaderCode);
		$('.error-container').removeClass('error-container');
		$('input').removeClass('error');

		var data = $(this).serialize();
		data = data + '&ajax=true';

		$.ajax({
			url: $(location).attr('href'),
			data: data,
			type: 'POST',
			success: function(data) {
				if (data != "Error") {
					//success message.
					if(data.success == false) {
						var error_message = $('<span>').addClass('error')
									.append($('<span>').addClass('icon'))
									.append($('<span>').addClass('text').text(data.error[0].message));
						$(this).find(".loading-errors").html(error_message);
						$(this).find('input[name="' + data.error[0].field + '"]').addClass('error-input');
						$('body').animate({scrollTop: $("#form").offset().top - 80},"slow");
					} else {
						$("#form").html(data.success);
					}
				} else {
					alert("There was a problem, sorry!");
				}
			}.bind(this),
			dataType: "json"
		});

		return false;

	}).on('submit', '#booking-form', function(){
		$(this).find(".loading-errors").html(svgPurpleLoaderCode);
		$('.error-container').removeClass('error-container');
		$('input').removeClass('error');

		var data = $(this).serialize();
		data = data + '&ajax=true';

		$.ajax({
			url: $(location).attr('href'),
			data: data,
			type: 'POST',
			success: function(data) {
				if (data != "Error") {
					//success message.
					if(data.success == false) {
						var error_message = $('<span>').addClass('error')
									.append($('<span>').addClass('icon'))
									.append($('<span>').addClass('text').text(data.error[0].message));
						$(this).find(".loading-errors").html(error_message);
						$(this).find('input[name="' + data.error[0].field + '"]').addClass('error-input');
						$('body').animate({scrollTop: 0},"slow");
					} else {
						$("#booking-form").html(data.success);
					}
				} else {
					alert("There was a problem, sorry!");
				}
			}.bind(this),
			dataType: "json"
		});

		return false;

	}).on('submit', '#skin-consultation-form', function(){

		$(this).find(".loading-errors").html(svgPurpleLoaderCode);
		$('.error-container').removeClass('error-container');
		$('input').removeClass('error');

		var data = $(this).serialize();
		data = data + '&ajax=true';

		$.ajax({
			url: $(location).attr('href'),
			data: data,
			type: 'POST',
			success: function(data) {
				if (data != "Error") {
					//success message.
					if(data.success == false) {
						var error_message = $('<span>').addClass('error')
									.append($('<span>').addClass('icon'))
									.append($('<span>').addClass('text').text(data.error[0].message));
						$(this).find(".loading-errors").html(error_message);
						$(this).find('input[name="' + data.error[0].field + '"]').addClass('error-input');
						$('body').animate({scrollTop: 0},"slow");
					} else {
						$("#skin-consultation-form").html(data.success);
					}
				} else {
					alert("There was a problem, sorry!");
				}
			}.bind(this),
			dataType: "json"
		});

		return false;

	}).on('click','.js-consultation-popup', function(){
		open_popup('#skin-consultation');
		return false;
	}).on('click','.js-book-popup', function(){
		open_popup('#book-now');
		return false;
	}).on('click','.overlay-bg, .js-close-popup',function(){
		close_popups();
		return false;
	});

	$('html').attr('data-useragent', navigator.userAgent);

	setTimeout(animate_objs,300);
});

var svgLoaderCode = '<svg width="24px" height="30px" viewBox="0 0 24 30" style="enable-background:new 0 0 50 50;" xml:space="preserve">\
					    <rect x="0" y="13" width="4" height="5" fill="#fff">\
					      <animate attributeName="height" attributeType="XML"\
					        values="5;21;5" \
					        begin="0s" dur="0.8s" repeatCount="indefinite" />\
					      <animate attributeName="y" attributeType="XML"\
					        values="13; 5; 13"\
					        begin="0s" dur="0.8s" repeatCount="indefinite" />\
					    </rect>\
					    <rect x="10" y="13" width="4" height="5" fill="#fff">\
					      <animate attributeName="height" attributeType="XML"\
					        values="5;21;5" \
					        begin="0.25s" dur="0.8s" repeatCount="indefinite" />\
					      <animate attributeName="y" attributeType="XML"\
					        values="13; 5; 13"\
					        begin="0.25s" dur="0.8s" repeatCount="indefinite" />\
					    </rect>\
					    <rect x="20" y="13" width="4" height="5" fill="#fff">\
					      <animate attributeName="height" attributeType="XML"\
					        values="5;21;5" \
					        begin="0.5s" dur="0.8s" repeatCount="indefinite" />\
					      <animate attributeName="y" attributeType="XML"\
					        values="13; 5; 13"\
					        begin="0.5s" dur="0.8s" repeatCount="indefinite" />\
					    </rect>\
					  </svg>';

var svgPurpleLoaderCode = '<svg width="24px" height="30px" viewBox="0 0 24 30" style="enable-background:new 0 0 50 50;" xml:space="preserve">\
					    <rect x="0" y="13" width="4" height="5" fill="#3d104f">\
					      <animate attributeName="height" attributeType="XML"\
					        values="5;21;5" \
					        begin="0s" dur="0.8s" repeatCount="indefinite" />\
					      <animate attributeName="y" attributeType="XML"\
					        values="13; 5; 13"\
					        begin="0s" dur="0.8s" repeatCount="indefinite" />\
					    </rect>\
					    <rect x="10" y="13" width="4" height="5" fill="#3d104f">\
					      <animate attributeName="height" attributeType="XML"\
					        values="5;21;5" \
					        begin="0.25s" dur="0.8s" repeatCount="indefinite" />\
					      <animate attributeName="y" attributeType="XML"\
					        values="13; 5; 13"\
					        begin="0.25s" dur="0.8s" repeatCount="indefinite" />\
					    </rect>\
					    <rect x="20" y="13" width="4" height="5" fill="#3d104f">\
					      <animate attributeName="height" attributeType="XML"\
					        values="5;21;5" \
					        begin="0.5s" dur="0.8s" repeatCount="indefinite" />\
					      <animate attributeName="y" attributeType="XML"\
					        values="13; 5; 13"\
					        begin="0.5s" dur="0.8s" repeatCount="indefinite" />\
					    </rect>\
					  </svg>';

$(window).bind("load", function () {

});

$(window).on("scroll",function(){
	animate_objs();
});

 $(window).scroll(throttle(function () {
   animate_objs();
}, 100));

function resize() {

}

function check_width_max(maxwidth) {
    /**** CHECKS THAT THE WINDOW IS NARROWER THAN MAXWIDTH  ****/
   var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
   return parseInt(width) <= parseInt(maxwidth);
}

function check_width_min(minwidth) {
    /**** CHECKS THAT THE WINDOW IS WIDER THAN MINWIDTH  ****/
   var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
   return parseInt(width) >= parseInt(minwidth);
}

function check_height_max(maxheight) {
    /**** CHECKS THAT THE WINDOW IS SMALLER THAN MAXHEIGHT  ****/
   var height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
   return parseInt(height) <= parseInt(maxheight);
}

function check_height_min(minheight) {
    /**** CHECKS THAT THE WINDOW IS TALLER THAN MINHEIGHT  ****/
   var height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
   return parseInt(height) >= parseInt(minheight);
}

function matchHeights() {
   var classes = ['same_height', 'same_height_2', 's_height'];
   var height = 0;
   if (check_width_min(600)) {
       $.each(classes, function (_, className) {
           height = 0;
           $('.' + className).css("min-height", "");
           if(check_height_min(760) && check_width_min(760)){
               if(className === 'same_height_2'){
                   return;
               }
           }
           $('.' + className).each(function (i, obj) {
               if ($(this).outerHeight() > height) {
                   height = $(this).outerHeight();
               }
           });
           $('.' + className).css("min-height", height);
       });
   } else {
       $.each(classes, function (_, className) {
           $('.' + className).css("min-height", "");
       });
   }
}

function refreshObj(selector){
	var obj = $(selector),
		content = obj.html();
	obj.html(content);
}


function open_popup(id){
	var $popup = $(id);
	$('body').addClass('perspective');
	$('.overlay-bg').addClass('show-overlay');
	$popup.addClass('show-popup');
	$("html, body").animate({ scrollTop: 0 }, "slow");
}

function close_popups(){
	$('.overlay-bg').removeClass('show-overlay');
	$('.popup-form').removeClass('show-popup');
	$('body').removeClass('perspective');
}

function animate_objs(){
	$('.js-animate').each(function () {
		var offset = 100;
		if(typeof $(this).attr('data-offset') !== 'undefined'){
			offset = parseInt($(this).attr('data-offset'));
		}
        $(this).viewportChecker({
            classToAdd: 'play',
            offset:    offset
        });
    });
}

function throttle(fn, threshhold, scope) {
    threshhold || (threshhold = 250);
    var last,
        deferTimer;
    return function () {
        var context = scope || this;

        var now = +new Date,
            args = arguments;
        if (last && now < last + threshhold) {
            // hold on to it
            clearTimeout(deferTimer);
            deferTimer = setTimeout(function () {
                last = now;
                fn.apply(context, args);
            }, threshhold);
        } else {
            last = now;
            fn.apply(context, args);
        }
    };
}
